module.exports = __webpack_public_path__ + "static/Pan_new-9be8d4375d4b63eb5625c294e0668e1c.svg";